import React from "react";
import "./Loader.css";

const Loader = () => {
    return (
        <div className="loding-div">
            <div className="loading-overlay">
                <div className="loading-spinner"></div>
            </div>
        </div>
    );
};

export default Loader;
